module.exports = __webpack_public_path__ + "static/img/yumeigui.e8cce38.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/yumeigui.png
// module id = S8Pr
// module chunks = 1